var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg038Flashlight = function Svg038Flashlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.671 271.721 240.279 131.329l-10.607 31.82 119.179 119.179zM405.934 169.706l-21.212-21.215 63.638-63.638-21.213-21.215-63.64 63.64-21.213-21.212 63.64-63.64L363.507 0 257.441 106.066l148.493 148.493L512 148.491l-42.426-42.425zM0 405.934 106.066 512l215.016-215.016-106.066-106.065zm172.588-45.31-21.213-21.213 63.64-63.64 21.213 21.213z"
  })));
};
export default Svg038Flashlight;